export const RoutePath = {
  home: "/",
  teacherList: "/teachers",
  login: "/login",
  studentDashboard: "/dashboard",
  teacherDashboard: "/dashboard",
  joinTeacher: "/jointeacher",
  lessons: "/lessons",
  invoice: "/invoice",
  paySuccess: "/payment-success",
  payFail: "/payment-fail",
};
